import { UnderMaintenance } from '@/components/ui';

export const ReportStock = () => {
    return <UnderMaintenance />;
};

ReportStock.displayName = 'ReportStock';
